module.exports = __webpack_public_path__ + "static/media/Menu.15c40c12.JPG";